<template>
  <div class="vue-create-county-wrap">
    <div class="controls-container-wrapper">
      <header>Add new county</header>
      <!-- name -->
      <div class="controls-container">
        <div class="control">
          <label for="utility">Name:</label>
          <input v-model="newCounty.name" placeholder="County name" type="text" class="name" v-bind:disabled="creatingCounty">
        </div>
      </div>
      <!-- code -->
      <div class="controls-container">
        <div class="control">
          <label for="utility">Code:</label>
          <input v-model="newCounty.code" placeholder="County code" type="text" class="code" v-bind:disabled="creatingCounty">
        </div>
      </div>
    </div>
    <div
    class="error-message"
    v-if="createCountyErrorMessage">{{createCountyErrorMessage}}</div>
    <div class="create-county-footer">
      <b-spinner v-if="creatingCounty" class="ajax-spinner"></b-spinner>
      <template  v-if="!creatingCounty">
        <b-button @click="hide" v-bind:disabled="creatingCounty">Cancel</b-button>
        <b-button @click="createCounty" v-bind:disabled="creatingCounty || !newCounty.name || !newCounty.code">Create County</b-button>
      </template>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";

export default {
  name: 'CreateCountyForm',
  components: {

  },
  props: {
    hide: Function,
    getAllCounties: Function,
    createCountySuccess: Function
  },
  data() {
    return {
      creatingCounty: undefined,
      newCounty: {},
      fadeErrorMessage: undefined,
      createCountyErrorMessage: undefined
    }
  },
  methods: {
      createCounty() {
        console.warn('createCounty ->');
        console.dir(this.newCounty);

        this.createCountyErrorMessage = false;
        this.creatingCounty = true;

        const postData = {
          name: this.newCounty.name,
          code: this.newCounty.code,
        };

        try {
          API.CreateCounty(postData).then(() => {
            this.creatingCounty = false;
            this.getAllCounties();
            this.createCountySuccess(`${postData.name} created`);
          }, err => {
            console.error('CreateCounty - ERROR');
            console.dir(err);

            this.creatingCounty = false;

            if (err
            && err.response
            && err.response.data) {
              this.createCountyErrorMessage = err.response.data;
            } else {
                this.createCountyErrorMessage = `Error creating county ${this.newCounty.name}`;
            }
          })
        } catch (err) {
            this.creatingCounty = false;
            console.error('CreateCounty - cath - ERROR');
            console.dir(err);
        }
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

.ajax-spinner{
  position: relative;
  top: 14px;
  right: 10px;
  height: 40px;
  width: 40px;
  font-size: 22px;
  color: #fbd850;
}

.error-message{
  display: block;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #800000;
  -webkit-transition: all 2s ease-in-out;
  -moz-transition: all 2s ease-in-out;
  -o-transition: all 2s ease-in-out;
  transition: all 2s ease-in-out;

  &.fade {
      opacity: 0;
  }
}

.controls-container-wrapper{
  header{
    margin: 20px 0 20px 5px;
    font-weight: 500;
    color: #231f20;
  }

  .controls-container {
    width: 80%;
    margin-bottom: 20px;
    padding: 10px;
    background-color: $modalGrey;

    label {
      margin-right: 10px;
      font-weight: bold;
    }

    input[type="text"] {
      width: 100%;
    }

    h4{
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.error-message{
  margin: 20px 0;
  font-weight: bold;
  color: #800000;
}

.create-county-footer{
  .btn{
    margin-right: 10px;

    &:last-child{
      margin-right: 0;
    }
  }
}
</style>
